<template>
    <div v-if="service">
        <b-modal
            v-model="show_modal_local"
            :title="'Реактирование опции'"
            class="modal-primary"
            size="md"
            ok-variant="primary"
            @hide.prevent
            @ok="handleOk"
            @cancel="handleCancel"
            @close="handleCancel"
            ref="my-modal"
        >
            <div class="row">
                <div class="col col-12">
                    <b-form-group
                        label="Наименование опции"
                        :invalid-feedback="veeErrors.first('title')"
                        :state="validateState('title')"
                    >
                        <input
                            class="form-control"
                            type="text"
                            v-model="service.title"
                            v-validate="{ required:true, max:200 }"
                            name="title"
                            data-vv-as="'Наименование опции'"
                            placeholder="Укажите наименование опции"
                            :state="validateState('title')"
                        >
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col col-12">
                    <b-form-group
                        label="Краткое описание"
                        :invalid-feedback="veeErrors.first('description')"
                        :state="validateState('description')"
                    >
                        <input
                            class="form-control"
                            type="text"
                            v-model="service.description"
                            v-validate="{ max:300 }"
                            name="description"
                            data-vv-as="'Краткое описание'"
                            placeholder="Укажите краткое описание (до 300 символов)"
                            :state="validateState('description')"
                        >
                    </b-form-group>
                </div>
            </div>


            <template slot="modal-footer" slot-scope="{ ok, cancel, close }">
                <b-button size="sm" variant="outline-secondary" @click="cancel()">
                    Закрыть
                </b-button>
                <b-button size="sm" variant="outline-success" @click="ok()">
                    Сохранить
                </b-button>
            </template>
        </b-modal>
    </div>
</template>


<script>
    import { functions } from '@/functions';
    import { functions_hotel_data } from '@/functions_hotel_data';
    import { functions_period } from '@/functions_period';

    export default {
        name: 'ServiceEditDialog',
        mixins: [functions, functions_hotel_data],
        data: function () {
            return {
            };
        },
        model: {
            prop: "category_id",
            event: "hide"
        },
        props: {
            category_id: Number,
        },
        watch: {
        },
        methods: {
            handleCancel: function () {
                this.$emit("hide", 0);
            },
            handleOk: function () {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.saveService(function (self) {
                            self.$emit("changed", self.service.id);
                            self.$emit("hide", 0);
                        }, this);
                    }
                });
            },
        },
        computed: {
            show_modal_local: {
                get: function () {
                    return this.is(this.service);
                },
                set: function (newValue) {}
            },
        },
        created: function() {
            this.loadService(this.category_id);
        },
    }
</script>
